import { render, staticRenderFns } from "./TeamsForm.vue?vue&type=template&id=271604fb"
import script from "./TeamsForm.vue?vue&type=script&lang=js"
export * from "./TeamsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports